export default "__VITE_ASSET__93c420f7__"